import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ILateDonorReviewsResponse } from '@nkr/store/index';
import { ILateDonorReviews } from '@nkr/models/index';
import { GridWrapper, HeaderWrapper } from './styles';
import { AgGridReact, AgGridColumnProps, AgGridColumnGroupProps } from 'ag-grid-react';
import {
    IHeaderParams, GridApi, ColumnApi, GridReadyEvent,
    CsvExportParams, ValueGetterParams, ProcessCellForExportParams, FirstDataRenderedEvent, ICellRendererParams
} from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { FormControl, Button, OverlayTrigger, Popover, Well, FormGroup, ControlLabel } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import { Utility } from '@nkr/services/utility';

type MyColumn = AgGridColumnProps | AgGridColumnGroupProps;

interface IProps {
    centerId: number,
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLateDonorReviews: (centerId: number, year: number, month: number) => Promise<ILateDonorReviewsResponse>
}

type TProps = IProps & IDispatchProps;

interface IState {
    year: number,
    month: number,
    report: ILateDonorReviews[]
}

class LateDonorReviewsReportGrid extends React.Component<TProps, {}> {
    readonly state: IState = {
        year: 0,
        month: 0,
        report: []
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        e.api.sizeColumnsToFit();
    }

    // onGridSizeChanged = () => {
    //     // get the current grids width
    //     let gridWidth = document.getElementById('grid-wrapper').offsetWidth;

    //     // keep track of which columns to hide/show
    //     let columnsToShow = [];
    //     let columnsToHide = [];

    //     // iterate over all columns (visible or not) and work out
    //     // now many columns can fit (based on their minWidth)
    //     let totalColsWidth = 0;
    //     let allColumns = this.gridColumnApi.getAllColumns();

    //     for (let i = 0; i < allColumns.length; i++) {
    //         let column = allColumns[i];
    //         totalColsWidth += column.getMinWidth();

    //         if (totalColsWidth > gridWidth) {
    //             columnsToHide.push(column.getColId);
    //         } else {
    //             columnsToShow.push(column.getColId);
    //         }
    //     }

    //     // show/hide columns based on current grid width
    //     this.gridColumnApi.setColumnsVisible(columnsToShow, true);
    //     this.gridColumnApi.setColumnsVisible(columnsToHide, false);

    //     // fill out any available space to ensure there are no gaps
    //     this.gridApi.sizeColumnsToFit();
    // }

    componentDidMount = () => {
        let dateRange = Utility.getRange(moment().subtract(11, 'month'), moment().add(1, 'month'), 'month');

        let year = dateRange[1].get('year');
        let month = dateRange[1].get('month') + 1;

        this.getData(this.props.centerId, year, month);
    }

    getData = (centerId: number, year: number, month: number) => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getLateDonorReviews(centerId, year, month)
                .then((response: ILateDonorReviewsResponse) => {
                    this.setState({
                        year: year,
                        month: month,
                        report: response.data.results
                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    // handleUpdate = (event: React.FormEvent<HTMLFormElement>) => {
    //     event.preventDefault();

    //     var centerId = this.props.centerId;
    //     // var year = this.state.year;
    //     // var month = this.state.month;

    //     // this.getData(centerId, year, month);
    // }

    handleDateFilterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let d = moment(e.currentTarget.value);
        let month = d.get('month') + 1;
        let year = d.get('year');

        this.setState({
            month,
            year
        }, () => {
            this.getData(this.props.centerId, this.state.year, this.state.month);
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'late-donor-reviews.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;
                else if ((colDef.colId == 'expectedResponseDate') || (colDef.colId == 'responseDateTime') || (colDef.colId == 'dateRequested'))
                    return moment(params.value).format('MM/DD/YYYY');

                return params.value;
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    getOverlay = (id: number) => {
        let reportrecord = this.state.report.find(x => x.id == id);

        return (
            <Popover>
                {ReactHtmlParser(reportrecord.responseDetails)}
            </Popover>
        );
    }

    render = () => {
        const dateRange = Utility.getRange(moment().subtract(11, 'month'), moment().add(1, 'month'), 'month').map(x => x.date(1));

        if (this.state.report == null)
            return;

        const reportColumns: MyColumn[] = [
            {
                colId: 'Rank',
                field: 'rank',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        R#
                    </SortableHeaderComponent>,
                headerName: 'Rank',
                width: 55,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                resizable: true,
                suppressSizeToFit: true,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },
            {
                colId: 'donorCenterAlias',
                field: 'donorCenterAlias',
                headerName: 'D Center Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        D Center Alias
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorIsExportable',
                field: 'donorIsExportable',
                headerName: 'Donor Is Exportable',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor Is<br /> Exportable
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorAlias',
                field: 'donorAlias',
                headerName: 'D Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        D Alias
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'recipientCenterAlias',
                field: 'recipientCenterAlias',
                headerName: 'R Center Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                minWidth: 120,
                maxWidth: 140,
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        R Center Alias
                    </SortableHeaderComponent>,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'recipientAlias',
                field: 'recipientAlias',
                headerName: 'R Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        R Alias
                    </SortableHeaderComponent>,
                minWidth: 80,
                maxWidth: 100,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'recipientIsExportable',
                field: 'recipientIsExportable',
                headerName: 'Recipient Is Exportable',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Recipients<br /> Is Exportable
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'dateRequested',
                field: 'dateRequested',
                headerName: 'Date Requested',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Date Requested
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => { return moment(props.value).format('MM/DD/YYYY'); }
            },
            {
                colId: 'responseDateTime',
                field: 'responseDateTime',
                headerName: 'Response Date',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Response Date
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => { return moment(props.value).format('MM/DD/YYYY'); }
            },

            {
                colId: 'responseDetails',
                field: 'responseDetails',
                headerName: 'Response Details',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                minWidth: 140,
                maxWidth: 160,
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Response Details
                    </SortableHeaderComponent>,
                cellRendererFramework: (props: ICellRendererParams) =>
                    <div>
                        <OverlayTrigger container={this} trigger={['hover', 'focus']} placement='bottom' overlay={this.getOverlay(props.data.id)}>
                            <div>
                                {props.data.responseDetails.substring(0, 15)}...
                            </div>
                        </OverlayTrigger>
                    </div>,
                sortable: true,
                // sort: 'asc',
                resizable: true

            },
            {
                colId: 'safeKey',
                field: 'safeKey',
                headerName: 'Safe Key',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Safe Key
                    </SortableHeaderComponent>,
                minWidth: 160,
                maxWidth: 180,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'expectedResponseDate',
                field: 'expectedResponseDate',
                headerName: 'Expect Resp Date',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Expected<br /> Response Date
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => { return moment(props.value).format('MM/DD/YYYY'); }

            },
            {
                colId: 'secondsLate',
                field: 'secondsLate',
                headerName: 'Seconds Late',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Seconds <br />Late
                    </SortableHeaderComponent>,
                minWidth: 80,
                maxWidth: 100,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'isLate',
                field: 'isLate',
                headerName: 'Is Late',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Is Late
                    </SortableHeaderComponent>,
                minWidth: 80,
                maxWidth: 100,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'isPending',
                field: 'isPending',
                headerName: 'Is Pending',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Is Pending
                    </SortableHeaderComponent>,
                minWidth: 80,
                maxWidth: 100,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'daysLate',
                field: 'daysLate',
                headerName: 'Days Late',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Days Late
                    </SortableHeaderComponent>,
                minWidth: 80,
                maxWidth: 100,
                sortable: true,
                // sort: 'asc',
                resizable: true
            }

        ];

        const month = this.state.month < 10 ? '0' + this.state.month : this.state.month;
        const year = this.state.year;

        const currentMonth = `${month}/01/${year}`;

        return (
            <>
                <HeaderWrapper className='container-fluid' style={{ marginBottom: 20 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex' }}>
                            {/* <form className='form-inline' onSubmit={this.handleUpdate}>
                                <FormGroup style={{ marginRight: 10 }}>
                                    <ControlLabel>Year:</ControlLabel> &nbsp;
                                    <FormControl componentClass='select' onChange={this.handleYearChange}>
                                        {years.map((year, index) =>
                                            <option key={'yr-' + index} value={year} selected={this.state.year == year}>{year}</option>
                                        )}
                                    </FormControl>
                                </FormGroup>

                                <FormGroup style={{ marginRight: 10 }}>
                                    <ControlLabel>Month:</ControlLabel> &nbsp;
                                    <FormControl componentClass='select' onChange={this.handleMonthChange}>
                                        {months.map((month, index) =>
                                            <option key={'mo-' + index} value={month} selected={this.state.month == month}>{month}</option>
                                        )}
                                    </FormControl>
                                </FormGroup>

                                <Button bsStyle='primary' type='submit'>Update</Button>
                            </form> */}

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Filter by Month:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={currentMonth}
                                        onChange={this.handleDateFilterChange}>
                                        {dateRange.map(date =>
                                            <option key={`ctr-${date.format('MM/DD/YYYY')}`} value={date.format('MM/DD/YYYY')}>{date.format('MM/YYYY')}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                        </div>

                        <div>
                            <Button bsStyle={'warning'} onClick={this.handleExport}>Export CSV</Button>
                        </div>
                    </div>
                </HeaderWrapper>

                <div className='row'>
                    <div className='col-sm-12'>
                        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
                            <AgGridReact
                                enableCellTextSelection={true}
                                enableRangeSelection={true}
                                columnDefs={reportColumns}
                                rowData={this.state.report}
                                headerHeight={44}
                                noRowsOverlayComponentFramework={() =>
                                    <div>No data for the selected date range...</div>}
                                onGridReady={this.onGridReady}
                                // onGridSizeChanged={this.onGridSizeChanged}
                                onFirstDataRendered={(props: FirstDataRenderedEvent) => props.api.sizeColumnsToFit()}
                                suppressCellSelection={true}
                                // rowBuffer={10000}
                                onSortChanged={() => {
                                    this.gridApi.refreshCells();
                                }}
                            />
                        </GridWrapper>

                    </div>
                </div>
            </>
        );
    }
}

export default LateDonorReviewsReportGrid;